var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('Emoji',{staticClass:"emoji",attrs:{"backgroundColor":"#47413d","open":true},on:{"click":_vm.selectedEmoji}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }